import {
  formatInt as formatIntLocale,
  formatNumber,
  formatFixed,
  getNumberLocaleTag,
  localizeDigits,
} from "./numberLocale";

export { CHART_COLORS } from "../theme/chartPalette";
export { formatNumber, localizeDigits, formatPercent, formatFixed } from "./numberLocale";
export const formatInt = formatIntLocale;

export const pctColor = (p) =>
  p >= 100 ? "text-green-600" : p >= 80 ? "text-blue-600" : p >= 60 ? "text-amber-600" : "text-red-500";

export const pctBg = (p) =>
  p >= 100 ? "bg-green-100 text-green-700" : p >= 80 ? "bg-blue-100 text-blue-700"
    : p >= 60 ? "bg-amber-100 text-amber-700" : "bg-red-100 text-red-700";

export const pctBar = (p) =>
  p >= 100 ? "bg-green-500" : p >= 80 ? "bg-indigo-500" : p >= 60 ? "bg-amber-500" : "bg-red-500";

export const fmtNum = (n, decimals = 1) => {
  const v = parseFloat(n);
  if (n == null || n === "" || Number.isNaN(v)) return "—";
  // Quantities (کارتن / مشتری / …): keep full locale digits under 1M.
  // The old `v/1e3` path dropped the scale label, so 4678 rendered as "5".
  if (Math.abs(v) >= 1e9) {
    return `${formatFixed(v / 1e9, decimals)} میلیارد`;
  }
  if (Math.abs(v) >= 1e6) {
    return `${formatFixed(v / 1e6, decimals)} میلیون`;
  }
  return formatNumber(v, {
    maximumFractionDigits: decimals,
    minimumFractionDigits: 0,
  });
};

/** Sale / f-sale targets: always two decimal places (e.g. 25.22). */
export const fmtDec = (n, decimals = 2) => {
  const v = parseFloat(n);
  if (n == null || n === "" || Number.isNaN(v)) return "—";
  return formatNumber(v, {
    maximumFractionDigits: decimals,
    minimumFractionDigits: decimals,
  });
};

export const fmtInt = (n) => formatIntLocale(n, "0");

export const fmtRial = (n) => {
  const v = parseFloat(n) || 0;
  if (v >= 1e9) return `${formatFixed(v / 1e9, 1)} میلیارد`;
  if (v >= 1e6) return `${formatFixed(v / 1e6, 1)} میلیون`;
  if (v >= 1e3) return `${formatFixed(v / 1e3, 0)} هزار`;
  return Math.round(v).toLocaleString(getNumberLocaleTag());
};
